export enum Status {
	'null' = 0, // used to signal appointment status is changing
	'Upcoming' = 1,
	'Cancelled' = 2,
	'No Show' = 3,
	'Complete' = 4,
	'Checked In' = 5,
}
